import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of, Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class LoginServiceService {
  constructor(private http: HttpClient) {}

  // è·ååæ°å¼
  private getParam(name: string): string {
    const u = {};
    const urlArr = location.search.slice(1).split("&");
    for (const i in urlArr) {
      u[urlArr[i].split("=")[0]] = urlArr[i].split("=")[1];
    }
    return u[name];
  }

  // è·åè®¤è¯code
  get code(): string {
    return this.getParam("code");
  }

  /**
   * è®¾ç½®token
   * @param api  è·åtokenæ¥å£
   * @param redirectUri éå®åé¡µé¢
   */
  setToken(api: string, redirectUri: string): void {
    this.http.get<string>(api + `?code=${this.code}`).subscribe(data => {
      localStorage.setItem("user", JSON.stringify(JSON.parse(data).maps));
      window.location.href = redirectUri;
    });
  }
}
